import { HttpErrorResponse } from '@angular/common/http';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { WarehouseErrorDto } from './warehouse-error.dto';

export const ERROR_KEYS = {
    cell_empty: marker('error.warehouse.cell-empty'),
    cell_occupied: marker('error.warehouse.cell-occupied'),
    carton_cell_conflict: marker('error.warehouse.carton-cell-conflict'),
    session_scan_conflict: marker('error.warehouse.session-scan-conflict'),
    session_mode_required: marker('error.warehouse.session-mode-required'),
    carton_kind_mismatch: marker('error.warehouse.carton-kind-mismatch'),
    carton_external_warehouse_mismatch: marker('error.warehouse.carton-external-warehouse-mismatch'),
    carton_not_eligible: marker('error.warehouse.carton-not-eligible'),
    carton_not_placed: marker('error.warehouse.carton-not-placed'),
    carton_already_assigned: marker('error.warehouse.carton-already-assigned'),
    carton_closed: marker('error.warehouse.carton-closed'),
    carton_empty: marker('error.warehouse.carton-empty'),
    carton_item_shortage: marker('error.warehouse.carton-item-shortage'),
    carton_locked: marker('error.warehouse.carton-locked'),
    carton_not_locked: marker('error.warehouse.carton-not-locked'),
    carton_index_limit_reached: marker('error.warehouse.carton-index-limit-reached'),
    carton_not_closed: marker('error.warehouse.carton-not-closed'),
    carton_already_on_pallet: marker('error.warehouse.carton-already-on-pallet'),
    carton_not_on_pallet: marker('error.warehouse.carton-not-on-pallet'),
    carton_on_shelf: marker('error.warehouse.carton-on-shelf'),
    pallet_closed: marker('error.warehouse.pallet-closed'),
    pallet_empty: marker('error.warehouse.pallet-empty'),
    duplicate_request: marker('error.warehouse.duplicate-request'),
    printer_not_assigned: marker('error.printer.not-assigned'),
    printer_geometry_ambiguous: marker('error.printer.geometry-ambiguous'),
    printer_disabled: marker('error.printer.disabled'),
    printer_out_of_paper: marker('error.printer.out-of-paper'),
    printer_head_open: marker('error.printer.head-open'),
    printer_unreachable: marker('error.printer.unreachable'),
    print_failed: marker('error.printer.print-failed'),
};

type WarehouseErrorReason = keyof typeof ERROR_KEYS;

export class WarehouseError {
    readonly code: number;
    readonly key: string;
    readonly reason: WarehouseErrorReason | null;

    constructor(response: HttpErrorResponse, fallbackKey: string) {
        this.code = response.status;
        const backendCode = (<WarehouseErrorDto | null>response.error)?.error?.code;
        this.reason = backendCode && backendCode in ERROR_KEYS ? <WarehouseErrorReason>backendCode : null;
        this.key = this.reason ? ERROR_KEYS[this.reason] : fallbackKey;
    }
}
